import { interopDefault } from '~/router/utils'

export default [
  {
    name: '__trades',
    path: '/trades/',
    meta: { noFooter: false, inTrades: true },
    component: () =>
      interopDefault(
        import(
          '~/pages/trades/index.vue' /* webpackChunkName: "pages-trades-index.vue" */
        )
      )
  },
  {
    name: '__trades_page',
    path: '/trades/:cid',
    meta: { noFooter: true, inTrades: true },
    component: () =>
      interopDefault(
        import(
          '~/pages/trades/trades.vue' /* webpackChunkName: "pages-trades-trade.vue" */
        )
      ),
    redirect: { name: '__trades_swipe' },
    children: [
      {
        name: '__trades_swipe',
        path: '/trades/:cid/swipe',
        meta: { noFooter: true, inTrades: true },
        component: () =>
          interopDefault(
            import(
              '~/pages/trades/swipe.vue' /* webpackChunkName: "pages-trades-swipe.vue" */
            )
          )
      },
      {
        name: '__trades_matches',
        path: '/trades/:cid/matches',
        meta: { noFooter: true, inTrades: true },
        component: () =>
          interopDefault(
            import(
              '~/pages/trades/matches.vue' /* webpackChunkName: "pages-trades-matches.vue" */
            )
          )
      },
      {
        name: '__trades_likes',
        path: '/trades/:cid/likes',
        meta: { noFooter: true, inTrades: true },
        component: () =>
          interopDefault(
            import(
              '~/pages/trades/likes.vue' /* webpackChunkName: "pages-trades-likes.vue" */
            )
          )
      },
      {
        name: '__trades_liked',
        path: '/trades/:cid/liked',
        meta: { noFooter: true, inTrades: true },
        redirect: {
          name: '__trades_likes'
        }
      },
      {
        name: '__trades_liked-by',
        path: '/trades/:cid/liked-by',
        meta: { noFooter: true, inTrades: true },
        redirect: {
          name: '__trades_likes',
          query: { 'sub-tab': 'likedBy' }
        }
      },
      {
        name: '__trades_messages',
        path: '/trades/:cid/thread/:thread',
        meta: { noFooter: true, inTrades: true },
        component: () =>
          interopDefault(
            import(
              '~/pages/trades/messages.vue' /* webpackChunkName: "pages-trades-messages.vue" */
            )
          )
      }
    ]
  }
]
